import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";
import Faq from "./Faq";
import FormModal from "../../widgets/FormModal";


function Casestudy() {

    const [activeCase, setActiveCase] = useState('case1');
    const sidebarRef = useRef(null);
    const observer = useRef(null);

      const [show, setShow] = useState(false);
      const openIframeWindow = () => {
        setShow(!show);
      }

    // const cases = Array.from({ length: 3 }, (_, i) => `case${i + 1}`);
    const caseRefs = {
        case1: useRef(null),/* Chronic Inflammatory Response */
        case2: useRef(null),/* Diabetes Reversal */
        case3: useRef(null),/* Irritable bowel syndrome */
        case4: useRef(null),/* Cardiac Health & Wellness */
        case5: useRef(null),/* Chronic Inflammatory Response */
        case6: useRef(null),/* Fatty Liver */
        case7: useRef(null),/* Low Energy, BP, Sciatica, Migraine */
        case8: useRef(null),/* Fatty Liver */
        case9: useRef(null),/* Cardiac Health & Wellness */
        case10: useRef(null),/* Weight Loss */
    };

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '-50% 0px -50% 0px', // Trigger when section is in the middle of viewport
            threshold: 0,
        };

        observer.current = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveCase(entry.target.id); // entry.target.id = "case1", "case2", etc.
                }
            });
        }, options);

        // Observe all case sections
        Object.values(caseRefs).forEach((ref) => {
            if (ref.current) observer.current.observe(ref.current);
        });

        return () => {
            // Cleanup
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, []);

    // useEffect(() => {
    //     const sidebar = sidebarRef.current;
    //     if (!sidebar) return;

    //     const activeItem = sidebar.querySelector(".active");
    //     if (activeItem) {
    //         activeItem.scrollIntoView({
    //             behavior: "smooth",
    //             block: "center", // center the active item in the sidebar
    //         });
    //     }
    // }, [activeCase]);

    const changeCase = (caseId) => {
        setActiveCase(caseId);
        // Do whatever else you want when a case changes
        console.log(`Switched to: ${caseId}`);
        // caseRefs[caseId]?.current?.scrollIntoView({
        //     behavior: 'smooth',
        //     block: 'start',
        // });
        const element = caseRefs[caseId]?.current;

        if (element) {
            const topOffset = element.getBoundingClientRect().top + window.scrollY - 10;

            window.scrollTo({
                top: topOffset,
                behavior: 'smooth',
            });

        };
    }


    return (
        <>  <section className="light_bg">
            <Header />
            <div className="top_space"></div>

            <section className="ps">
                <div className="container">
                    <h1 className="hadding mb-4 mb-md-5">Case Studies</h1>

                    <div className="row">
                        <div className="col-lg-2 col-md-3 case_left_bardiv">
                            <ul className="case_left_bar" ref={sidebarRef} style={{ overflowY: "auto", maxHeight: "80vh" }}>
                                {Object.keys(caseRefs).map((caseId) => (
                                    <li
                                        key={caseId}
                                        style={{ cursor: "pointer" }}
                                        className={activeCase === caseId ? 'active' : ''}
                                    >
                                        <span onClick={() => changeCase(caseId)}>{caseId.replace('case', 'Case ',)}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div class="col-md-8 col-lg-9  ps-md-5" style={{ flex: 1 }}>

                            <div id="case1" ref={caseRefs.case1}>
                                <div class="d-flex gap-4 mb-5 align-items-center" >
                                    <img src="assets/img/response.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Chronic Inflammatory Response</h3>
                                </div>


                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>

                                    <ul class="mb-4 dot_list">
                                        <li>Weight – 86 kg (BMI 28.4 – Overweight)</li>
                                        <li>Constant fatigue, irritability, acidity</li>
                                        <li>Knee pain making daily life difficult</li>
                                        <li>Couldn’t run even 1 km</li>
                                        <li>Lifestyle included regular alcohol intake</li>
                                    </ul>

                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> LDL Cholesterol – High Risk: Predisposition to higher bad cholesterol → heart risk if weight not managed </li>
                                        <li> Magnesium & Zinc Deficiency – High Risk: Leading to poor muscle recovery, fatigue, immunity issues </li>
                                        <li> Carbohydrate & Weight Gain – Intermediate Risk: Easily gains weight on carb-heavy diets </li>
                                        <li> Emotional Eating – High Risk: More likely to overeat under stress </li>
                                        <li> Insulin Sensitivity – Intermediate Risk + Hyper insulinemic Hypoglycaemia – High Risk: Risk of sugar fluctuations → energy crashes </li>
                                        <li> Thyroid – Intermediate Risk: Slightly elevated TSH → slower metabolism </li>
                                        <li> Bone Mineral Density – Intermediate Risk: Adds to joint pain risk if weight not reduced </li>

                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Genetic-Led Personalized Plan</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Diet: High-protein, low-carb plan to match his carb-sensitivity genes and boost adiponectin for fat metabolism. </li>
                                        <li> Supplements: Magnesium & zinc to address deficiencies, support energy, muscle function, and immunity.
                                            Lifestyle: Alcohol reduction to lower acidity & improve liver function, stress- management to curb emotional eating.
                                        </li>
                                        <li>Exercise: Gradual, genetically guided cardio & strength plan focusing on injury prevention (due to higher injury risk markers). </li>
                                        <li> Metabolic Focus: Stabilizing blood sugar fluctuations with balanced meal timing to control insulin response and prevent hypoglycaemia fatigue.</li>

                                    </ul>

                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">90 Days Transformation:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Weight reduced from 86 kg → 74 kg (BMI from 28.4 → 24.4)</li>
                                        <li>Energy levels restored, no longer feeling constant fatigue </li>
                                        <li>Knee pain significantly reduced → improved mobility </li>
                                        <li> Can now run 4 km effortlessly</li>
                                        <li>Reduced acidity, better mood & mental clarity </li>
                                        <li> Long-term health risk for LDL & insulin sensitivity brought under control through lifestyle alignment</li>
                                    </ul>

                                    <p class="mb-2 h5 ">Overall Impact :</p>
                                    <ul class="mb-4 dot_list pb-md-5">
                                        <li> Genetic insights removed the guesswork — making the plan sustainable and effective</li>
                                        <li>Built resilience against weight regain (confirmed by normal “tendency to regain weight” gene marker)</li>
                                        <li>Created a healthier metabolic state that supports heart, joint, and emotional health</li>
                                    </ul>
                                </div>
                            </div>
                            <div id="case2" ref={caseRefs.case2}>

                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case2.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Diabetes Reversal</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>

                                    <ul class="mb-4 dot_list">
                                        <li>Age: 46, Finance Officer – high stress, irregular meal timings </li>
                                        <li>Weight: 66 kg, Height: 163 cm </li>
                                        <li>HBA1c: 12 (poorly controlled diabetes) </li>
                                        <li>Vision issues – early signs of diabetic retinopathy </li>
                                        <li> Microalbumin in urine – early kidney involvement</li>
                                        <li>Easily tired, frequent weakness, tingling sensations in hands & feet </li>
                                        <li>No weight loss despite strict diet efforts </li>
                                        <li> Sleep quality poor → adding to stress & glucose spikes</li>
                                    </ul>

                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li>Type 2 Diabetes Predisposition – Intermediate Risk: Higher baseline susceptibility, making sugar control harder. </li>
                                        <li>Insulin Sensitivity – Intermediate Risk: Lower sensitivity → higher blood sugar even with normal diet. </li>
                                        <li> Carbohydrate & Weight Gain – Intermediate Risk: Body prone to store carbs as fat, causing insulin spikes.</li>
                                        <li> Vitamin B6, B9 & Magnesium Deficiency Risks: Affecting nerve health, causing fatigue & tingling.</li>
                                        <li>Hyper insulinemic Hypoglycaemia – High Risk: Blood sugar fluctuations causing weakness episodes. </li>
                                        <li> Emotional Eating – High Risk + Low Stress Resilience: High-stress job worsening glucose spikes.</li>

                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Genetic-Led Personalized Plan</p>
                                    Dietary Strategy:
                                    <ul class="mb-4 dot_list">
                                        <li> Shifted to low-glycemic, high-protein, fiber-rich meals to reduce post- meal glucose spikes (aligned to carb-sensitivity gene).</li>
                                        <li>Added magnesium and B-complex supplementation to improve nerve function and reduce fatigue. </li>
                                        <li> Micronutrient plan for eye health (antioxidants & zinc for retinal support).</li>
                                    </ul>

                                    Lifestyle & Stress Protocol:
                                    <ul class="mb-4 dot_list">
                                        <li> Stress management techniques (guided breathing, scheduled work breaks) to address emotional eating and cortisol spikes. </li>
                                        <li> Improved sleep hygiene → fixed routine, early dinner to stabilize night glucose levels. </li>

                                    </ul>
                                    Lifestyle & Stress Protocol:

                                    <ul class="mb-4 dot_list">
                                        <li> Blood sugar monitoring + feedback loop every 15 days. </li>
                                        <li> EPLIMO based plan on glucose patterns and energy levels. </li>
                                    </ul>
                                    Exercise:
                                    <ul class="mb-4 dot_list">
                                        <li>Low-impact walking + guided strength work (per genetic injury risk markers) to improve insulin sensitivity safely.</li>
                                    </ul>

                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">After 5 Months of Continuous Program:</p>
                                    <ul class="mb-4 dot_list pb-md-5">
                                        <li> HBA1c: Dropped from 12 → 7.5 in 3 months → 5.6 in 5 months (near remission levels).</li>
                                        <li>Kidney Function: Microalbumin normalized → reduced risk of diabetic nephropathy. </li>
                                        <li> Vision: Improvement in early diabetic retinopathy changes (as reported in follow-up eye check).</li>
                                        <li>Energy: Significant improvement, no more sudden fatigue or tingling episodes. </li>
                                        <li>Sleep: Better quality sleep, reduced stress response. </li>
                                        <li>Overall Well-being: Higher productivity at work, better emotional balance. </li>
                                        <li>Sustainability: Genetic insight allowed creation of a long-term lifestyle plan, reducing risk of relapse. </li>
                                    </ul>

                                </div>
                            </div>
                            <div id="case3" ref={caseRefs.case3}>

                                <div class="d-flex gap-4 mb-5 align-items-center" >
                                    <img src="assets/img/case3.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Irritable bowel syndrome</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Age: 18 yrs.- Student  </li>
                                        <li> Gender: Female </li>
                                        <li> Chronic painful bowel movements & fissures since age 13 </li>
                                        <li> Frequent bloating, abdominal pain, irregular stools </li>
                                        <li> Weakness and low energy due to poor nutrient absorption </li>
                                        <li> Recurrent flare-ups worsened by stress (especially around exams)</li>
                                        <li> Social embarrassment → impacting emotional health  </li>
                                    </ul>

                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> Inflammatory Risk: Genetic predisposition to Crohn’s Disease and gut inflammation  (markers like ES78289, ES43211) → explains chronic gut irritation. </li>
                                        <li> Lactose Intolerance: High-risk marker (ES51679) → likely triggering ongoing inflammation when consuming dairy. </li>
                                        <li> Vitamin K & Magnesium Deficiency Risks: Slower mucosal healing and increased susceptibility to fissures. </li>
                                        <li> Stress Sensitivity & Anxiety Genes (ES75094, ES45476): Heightened gut- brain axis response → flare-ups triggered by emotional stress. </li>

                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Precision, Gene-Led Program:</p>
                                    Dietary Modifications:
                                    <ul class="mb-4 dot_list">
                                        <li>Strict Low-FODMAP diet to minimize bloating triggers and inflammation. </li>
                                        <li> Complete elimination of dairy to prevent immune reactions from lactose intolerance.</li>
                                        <li>Inclusion of anti-inflammatory foods rich in Omega-3s, polyphenols, and soluble fibre to improve gut microbiome balance. </li>
                                    </ul>

                                    <p>Targeted Supplementation:</p>

                                    <ul class="mb-4 dot_list">
                                        <li>Magnesium + Zinc: Support bowel motility, reduce stress-induced spasms, improve mucosal repair. </li>
                                        <li>Vitamin K: Aid tissue healing and reduce inflammation.</li>

                                    </ul>
                                    <p> Stress-Management Protocol:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Mindfulness breathing and guided relaxation sessions to regulate the gut-brain axis. </li>
                                        <li>Fixed sleep schedule to strengthen immune and inflammatory response regulation.</li>
                                    </ul>
                                    <p> Symptom Monitoring:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Regular tracking of bowel movement patterns, pain episodes, and food triggers to refine diet plan dynamically.</li>
                                        <li>
                                            Early intervention strategies to prevent escalation during flare-ups. </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">3.	Outcome</h4>
                                    <p class="mb-4 h5">Short-Term (3 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Reduced bloating and abdominal pain episodes. </li>
                                        <li> Softer, regular bowel movements with less straining → fissure healing accelerated. </li>
                                        <li> Noticeable improvement in energy levels due to better nutrient absorption. </li>
                                    </ul>

                                    <p class="mb-4 h5">Extended Follow-Up (1 Year):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Drastically fewer flare-ups even during high-stress periods (exam seasons).</li>
                                        <li>Reduced reliance on pain medications and laxatives. </li>
                                        <li> Stable gut health with improved emotional well-being and confidence.</li>
                                        <li>Sustainable dietary habits that fit into her lifestyle without feeling restrictive. </li>

                                    </ul>

                                    <h4 class="problem_item mb-4">4.	Key Outcome</h4>
                                    <p class="mb-4 h5 pb-md-5">EPLIMO decoded the hidden drivers of the clients IBS — inflammation risk, lactose intolerance, and stress sensitivity - and converted them into a precise, actionable plan. This shifted her journey from symptomatic treatment to root-cause management, giving her long- term control over her gut health.</p>


                                </div>
                            </div>
                            <div id="case4" ref={caseRefs.case4}>
                                <div class="d-flex gap-4 mb-5 align-items-center" >
                                    <img src="assets/img/case4.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600"> Cardiac Health & Wellness</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>
                                    <p class="mb-4 h5">Age: 32 yrs. | Height: 166.5 cm | Weight: 75 kg<br />
                                        Biomarkers:</p>



                                    <ul class="mb-0  dot_list">
                                        <li> Triglycerides – 268 mg/dL (High) </li>
                                        <li> LDL Cholesterol – 190 mg/dL (Very High) </li>
                                        <li> HDL Cholesterol – 36 mg/dL (Low) </li>
                                        <li> Uric Acid – 8.7 mg/dL (High)</li>
                                        <li> Homocysteine – 13 (Elevated, ↑CV risk) </li>
                                        <li>  Vitamin D – 7 (Severe Deficiency) </li>
                                    </ul>
                                    <p>Family history of cardiovascular disease — father, paternal uncle, and grandfather had early cardiac deaths before age 50.
                                        Complaints of fatigue, occasional joint pain, fear of early heart attack.</p>

                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> APOA5 Variant: Predisposes to high triglycerides, worsened by high-fat diets.</li>
                                        <li>CETP Variant: Leads to low HDL cholesterol, reducing heart protection. </li>
                                        <li>FADS1 Variant: Increases LDL when PUFA (polyunsaturated fats) are overconsumed. </li>
                                        <li> SLC2A9 Variant: Predisposes to hyperuricemia and gout.</li>
                                        <li>B6 Deficiency Risk: May contribute to elevated homocysteine, compounding heart risk.</li>
                                        <li> B9 Intermediate Risk: Requires optimal folate intake to maintain methylation cycle and vascular health.
                                        </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Precision, Gene-Led Program:</p>
                                    Dietary Modifications:
                                    <ul class="mb-4 dot_list">
                                        <li> Low-Fat, MUFA-Rich Plan: Olive oil, avocado, almonds, walnuts for heart-friendly fats. </li>
                                        <li> High-Fibre (30–35 g/day): Whole grains, pulses, vegetables to lower LDL & triglycerides.</li>
                                        <li> Low-Purine Diet: Reduce red meat, alcohol, and seafood to manage uric acid. </li>
                                        <li> Vitamin-D Repletion: High-dose supplementation to correct deficiency and support heart & im</li>
                                    </ul>

                                    <p>Targeted Supplementation:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Omega-3 fatty acids for HDL boost and triglyceride lowering. </li>
                                        <li> Magnesium + B-complex (B6, B9, B12) to reduce homocysteine and improve energy. </li>
                                        <li>  Antioxidant support (Vitamin C, E) to lower oxidative stress and protect vessels.</li>

                                    </ul>
                                    <p>   Lifestyle & Exercise:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Aerobic Exercise: Brisk walking/swimming 30–45 mins, 5 days/week to raise HDL. </li>
                                        <li> Strength Training: 2x weekly to improve muscle mass & metabolism. </li>
                                        <li> Hydration: 3–3.5 L/day to support kidney clearance of uric acid. </li>
                                        <li> Stress management and mindfulness to reduce inflammatory load. </li>
                                    </ul>
                                    <p>Monitoring:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Monthly lipid profile + uric acid monitoring. </li>
                                        <li>Homocysteine re-check every 3 months to evaluate B-vitamin intervention efficacy. </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">Short-Term (3 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Triglycerides dropped by 20–30% </li>
                                        <li> LDL reduced significantly with dietary compliance</li>
                                        <li>HDL improved by 10–15% with exercise + omega-3 </li>
                                        <li>Uric acid levels trending toward normal </li>
                                        <li> Energy levels improved; joint pain reduced</li>
                                        <li>Vitamin D levels improving, reducing risk of endothelial dysfunction </li>
                                    </ul>

                                    <p class="mb-4 h5">Long-Term (12 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Lipid profile close to optimal range, maintaining cardiometabolic health </li>
                                        <li> Normalized uric acid with sustained low-purine diet and hydration </li>
                                        <li> Reduced homocysteine → lowering cardiovascular event risk </li>
                                        <li> Developed sustainable, heart-healthy eating and exercise habits </li>
                                    </ul>

                                    <p class="mb-4 h5"> Outcome:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Strong preventive impact against early cardiac events given family history</li>
                                    </ul>

                                    <h4 class="problem_item mb-4">4.	Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">EPLIMO decoded his genetic roadmap — from lipid metabolism to uric acid regulation — and built a precision plan that targeted each risk pathway.
                                        Instead of merely controlling numbers, this approach worked upstream, reversing risk factors and protecting him from the same early cardiac fate seen in his family.                            </p>
                                </div>
                            </div>
                            <div id="case5" ref={caseRefs.case5}>
                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case5.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Chronic Inflammatory Response</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>
                                    <p class="mb-4 h5">Female, (53) once an active sports and fitness enthusiast, saw her health spiral after an emotional trauma in 2016 that led to weight gain of 25 kg within a year.</p>

                                    <p class="mb-4  ">She came to us with:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Prediabetes (HOMA-IR high → strong insulin resistance)</li>
                                        <li> Low energy and inflammation markers (low vitamin D, ferritin, omega-3; very high omega-6/omega-3 ratio)</li>
                                        <li>B12 deficiency causing fatigue </li>
                                        <li>Elevated IgE indicating systemic inflammation </li>
                                        <li> Fluctuating weight and difficulty losing fat despite diet attempts</li>

                                    </ul>


                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> High risk for LDL cholesterol elevation and intermediate risk for myocardial infarction → higher cardiovascular risk. </li>
                                        <li>
                                            Intermediate risk for obesity & high BMI – genetically prone to weight retention. </li>
                                        <li>
                                            Intermediate risk for Type 2 diabetes & insulin sensitivity issues – genetically less efficient glucose regulation. </li>
                                        <li>
                                            High risk for magnesium deficiency & PUFA-related cholesterol sensitivity – making her more prone to inflammation and lipid imbalance.
                                            Intermediate risk for vitamin B6 and B9 deficiency – affecting energy metabolism and mood. </li>
                                        <li>
                                            Intermediate risk for autoimmune activation – meaning chronic inflammation can flare faster if not controlled.
                                        </li>
                                    </ul>
                                    <p> All these risks together created a metabolic storm — weight gain, high inflammation, sluggish energy, and increased risk of heart disease and diabetes.</p>

                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Precision, Gene-Led Program:</p>
                                    <p class=" ">Nutritional & Genetic Match:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Low-gluten, anti-inflammatory diet tailored to her genetic predisposition for PUFA sensitivity and insulin resistance.</li>
                                        <li> Focus on MUFA-rich oils (coconut oil, homemade ghee) and elimination of seed oils (sunflower/palm oil) that aggravate her inflammatory genes.</li>
                                        <li>
                                            Increased protein and low-carb pattern to improve adiponectin levels (supported by her genotype’s better response to high-protein diet). </li>
                                        <li>
                                            Micro-activity every hour to overcome genetic risk for weight gain and insulin resistance.</li>
                                    </ul>


                                    <p class="mb-4 h5">Targeted Supplementation (Gene-Guided):</p>
                                    <ul class="mb-4 dot_list">
                                        <li>  Curcumin Latte to down-regulate inflammatory gene expression (PUFA/AA ratio support).</li>
                                        <li> Natural E to support PUFA regulation, reducing oxidative damage in genetically sensitive lipid metabolism. </li>
                                        <li> Magnesium to counter her genetically predicted deficiency, improving insulin sensitivity.
                                        </li>
                                        <li> Chromium Picolinate to tackle insulin resistance.
                                        </li>
                                        <li> Omega-3 supplementation to restore the Omega-6:Omega-3 balance (19.6 → optimal range 3.7–14.4) and protect against cardiac risk linked to LDL genotype.
                                        </li>
                                        <li>B12 supplementation to correct deficiency and support energy production. </li>


                                    </ul>
                                    <p class="mb-4 h5"> Lifestyle & Mindset Shift:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Breathing exercises & stress management to address emotional eating tendency and cortisol-driven weight retention. </li>
                                        <li>Structured sleep hygiene protocol to regulate hormonal balance and reduce genetic risk for obesity.</li>
                                    </ul>
                                    <p class="mb-4 h5">Monitoring:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Regular monitoring of blood sugar, lipid panel, and inflammatory markers to track progress and adjust protocols.</li>
                                    </ul>



                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">Outcome (After 6 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Insulin resistance reduced – HOMA-IR closer to normal range.</li>
                                        <li> Energy levels significantly better – no more mid-day crashes, able to be active consistently. </li>
                                        <li> Ferritin & B12 normalized, resulting in better stamina and improved mood.</li>
                                        <li> Omega-6/Omega-3 ratio reduced towards optimal → inflammation markers lowered.</li>
                                        <li> Weight stabilized and fat distribution improved without aggressive dieting.</li>
                                        <li> Better emotional balance & improved sleep quality, fewer stress-triggered eating episodes. </li>

                                    </ul>


                                    <h4 class="problem_item mb-4">Outcome:</h4>
                                    <ul class="mb-4 dot_list">
                                        <li>Overall cardiovascular risk lowered — creating a long-term buffer against diabetes and heart disease progression.</li>
                                    </ul>

                                    <h4 class="problem_item mb-4">4. Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">The client’s 6-month journey demonstrates that gene-driven, root-cause interventions don’t just create quick fixes — they build sustainable health resilience for the long term.
                                    </p>
                                </div>
                            </div>
                            <div id="case6" ref={caseRefs.case6}>
                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case6.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Fatty Liver</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>
                                    <p class="mb-4 ">Gender: Male</p>

                                    <p class="mb-4  ">Age: 51</p>
                                    <p class="mb-4  ">Occupation: Businessman with a demanding travel schedule</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Diabetes: Fasting sugar 129 mg/dL, HbA1c 6.6% (early Type 2 diabetes) </li>
                                        <li>  Fatty Liver (Grade I–II): Confirmed on ultrasound with mildly elevated ALT (SGPT)</li>
                                        <li className='mt-4'>
                                            <h5 class="mb-0 ">Lifestyle Issues:</h5>
                                            <ul class="mb-4 dot_list">
                                                <li>Frequent alcohol intake (social and work-related)</li>
                                                <li>Irregular meals due to constant travel. </li>
                                                <li>No structured exercise routine → high fatigue and poor energy. </li>
                                            </ul>
                                        </li>

                                        <li>Metabolic Risk: Insulin resistance (fasting insulin borderline high), weight fluctuations, risk of worsening fatty liver and heart disease if unaddressed.</li> </ul>

                                    <h5 class="mb-0">EPLIMO - Underlying Genetic Risks Identified:</h5>

                                    <ul class="mb-4 dot_list">
                                        <li>  Type 2 Diabetes Risk – Intermediate: Tendency for elevated blood sugar even on moderate-carb diets </li>
                                        <li>  Obesity & BMI Risk – Intermediate: Harder to maintain a stable weight, easier to regain lost weight </li>
                                        <li>  Lipid Sensitivity: Predisposed to elevated triglycerides and LDL with a high-fat diet and alcohol </li>
                                        <li> High Risk for LDL Cholesterol Elevation and Intermediate Risk for Myocardial Infarction: Indicates increased cardiovascular vulnerability
                                            Magnesium Deficiency Risk – High: Can worsen insulin resistance and fatigue  </li>
                                        <li>  Alcohol Sensitivity Genes – Intermediate: Slower breakdown of acetaldehyde, increasing liver stress even with moderate intake </li>

                                    </ul>

                                    <p>His genetics and lifestyle were amplifying each other — creating a perfect storm for metabolic syndrome and liver disease progression.</p>
                                    <h4 class="problem_item mb-4">2. Intervention</h4>
                                    <p class="mb-4 h5">Precision, Gene-Led Program:</p>
                                    <p class=" ">Nutrition & Lifestyle Reset:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Low-GI, moderate-protein, liver-friendly diet: High-fiber meals to stabilize glucose and reverse fatty liver </li>
                                        <li> Structured meal timing: Ensured regular meals during travel to reduce insulin spikes </li>
                                        <li> Strict alcohol reduction: In alignment with his alcohol sensitivity genes </li>
                                        <li> Hydration goal: 3 liters per day to support liver and kidney function </li>


                                    </ul>


                                    <p class="mb-4 h5">Targeted Supplementation:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Magnesium: Improved insulin sensitivity and reduced fatigue </li>
                                        <li> Curcumin: Reduced liver inflammation (aligned with genetic inflammatory risk) </li>
                                        <li> Omega-3 (1000 mg/day): Lowered liver fat and triglycerides </li>
                                        <li> Chromium Picolinate: Enhanced blood sugar control </li>
                                        <li> B-Complex + B12: Supported energy and reduced homocysteine-related heart risk </li>

                                    </ul>
                                    <p class="mb-4 h5"> Activity & Stress Management:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Travel-friendly exercise plan: 20–30 minutes of bodyweight routines plus 8,000 steps per day </li>
                                        <li>Breathing exercises: Helped reduce cortisol spikes that worsen glucose control</li>
                                    </ul>
                                    <p class="mb-4 h5"> Regular Tracking & Feedback</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Monthly fasting sugar and liver function tests </li>
                                        <li>Quarterly HbA1c and lipid profile reviews  </li>
                                        <li> Biweekly coaching sessions for accountability during travel </li>
                                    </ul>



                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">Outcome (After 6 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li>HbA1c: Reduced from 6.6% → 5.8% (near-normal range)</li>
                                        <li>Liver Health: ALT normalized, fatty liver grade improved</li>
                                        <li>Weight: Down by ~7 kg (primarily fat loss)</li>
                                        <li>Energy: Significant improvement, less fatigue during travel, higher productivity</li>
                                        <li>Alcohol Consumption: Reduced by 50%, leading to improved liver markers and better sleep</li>
                                        <li>Lifestyle: Consistent meal discipline, no more skipping breakfast or dinner</li>
                                        <li>Long-Term Risk Reduction:</li>
                                        <li>Lowered chances of progressing to Type 2 diabetes or advanced fatty liver disease.</li>
                                    </ul>

                                    <h5>Outcome:</h5>

                                    <ul class="mb-4 dot_list">
                                        <li>This client’s journey demonstrates that genetic insight combined with lifestyle alignment delivers results that go far beyond medication.</li>
                                    </ul>

                                    <h4 class="problem_item mb-4">4. Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">By tailoring his nutrition, supplementation, and daily routine to his DNA, he achieved measurable, sustainable improvements - all while maintaining a demanding business lifestyle.
                                    </p>
                                </div>
                            </div>
                            <div id="case7" ref={caseRefs.case7}>
                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case7.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Low Energy, BP, Sciatica, Migraine</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>



                                    <ul class="mb-4 dot_list">
                                        <li> Gender: Female</li>
                                        <li>Age: Not specified </li>
                                        <li> Low energy, hypertension, sciatica, and migraine</li>
                                    </ul>


                                    <h5 class="mb-1">She came to us with:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> Fasting Glucose: 110 mg/dL and HbA1c 5.8%, placing her in the pre-diabetic range</li>
                                        <li>Blood Pressure: 162/110 mmHg at baseline, requiring immediate monitoring and intervention </li>
                                        <li>Other Symptoms: Low energy levels and mild sciatica pain </li>
                                        <li> Weight: 77 kg at baseline</li>
                                    </ul>

                                    <h5 className='mb-4'>EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> Genetic report highlighted risks for magnesium & zinc deficiency, elevated homocysteine, reduced aerobic capacity, and higher risk of exercise injury. </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention <span className='h5'>(initiated immediately)</span> </h4>
                                    <p class="mb-4 h5">Week 0–1:</p>

                                    <ul class="mb-4 dot_list">
                                        <li> Started home BP monitoring, initiated dietary changes (reduced rice and late-night carbs, added more protein and leafy greens), and began gentle walking + stretching for sciatica. </li>
                                        <li> Supplements introduced: Krill oil, Magnesium, Zinc, Mito complex (before exercise), and Curcumin latte. </li>
                                        <li> Exercise plan: low-impact cardio (20 min walk daily), core stabilization, warm-ups before activity
                                        </li>
                                    </ul>


                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="mb-4 h5">Outcome (By Week 2):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Her blood pressure was being monitored twice daily and had already started trending lower than the initial 162/110 mmHg, though some variations remained.</li>
                                        <li>She reported slightly better energy and fewer afternoon slumps. </li>
                                        <li> Sleep quality improved after starting magnesium.</li>
                                    </ul>

                                    <p class="mb-4 h5">By Week 4 (1 Month):</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Her weight reduced from 77 kg to 75 kg, a steady 2 kg drop within the first month. </li>
                                        <li>Blood pressure was more stable, averaging closer to 140–145 systolic compared to the initial hypertensive range.
                                        </li>
                                        <li>She experienced better stamina during daily walks and her mild sciatica pain was less frequent with physiotherapy-guided stretches. </li>
                                        <li>She adhered well to the recommended supplements (Krill oil, Magnesium, Zinc, Mito complex, Curcumin latte). </li>

                                    </ul>

                                    <p class="mb-4 h5">By Week 6–8 (2 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Her blood pressure showed further control, with most readings staying around 130– 140/85–90 mmHg. </li>
                                        <li> Weight remained steady at 75 kg, with gradual inch loss observed around the waist. </li>
                                        <li> Energy levels were significantly better, and he extended walks to 30 minutes without discomfort.
                                        </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">4. Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">Her digestion improved with dietary modifications, and she was able to maintain reduced rice intake at night. <br />
                                        She was consistent in tracking BP and dietary logs, creating a strong base for follow- up labs.</p>
                                </div>
                            </div>
                            <div id="case8" ref={caseRefs.case8}>
                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case8.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Fatty Liver</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>



                                    <ul class="mb-4 dot_list">
                                        <li> Age, 44 yrs., Height 5’5” Weight :85 kg </li>
                                        <li>
                                            Grade 2 Fatty Liver, high cholesterol, pre-diabetes (HbA1c 6.2) </li>
                                        <li>
                                            Symptoms: fatigue, heaviness post meals especially after lunch, poor sleep, belly fat, brain fog
                                            Taking Multivitamins </li>
                                        <li>
                                            Baseline labs: High ALT/AST, GGT, Cholesterol, LDL, Triglycerides, low Vitamin D, low HDL </li>

                                    </ul>


                                    <h5 class="mb-4">   EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> High risk: Hypertriglyceridemia, Fat metabolism defects, PUFA response compromised, Magnesium & Zinc deficiency, Emotional eating, Depression risk, Low resilience to stress</li>
                                        <li> Intermediate risk: Insulin sensitivity, Carbohydrate-related weight gain, BMI tendency, Type 2 Diabetes predisposition</li>
                                        <li>Protective: Good fibre response for weight loss, improved metformin response
                                        </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention <small className='h5'>(90 Days)</small> </h4>
                                    <p class="  h5 mb-4">Precision, Gene-Led Program:</p>
                                    <p class=" h5">Diet:</p>

                                    <ul class=" dot_list">
                                        <li> Low-carb, high-fibre, anti-inflammatory (gene-guided → more fibre, less PUFA oils, avoid excess carbs/sugar)</li>

                                    </ul>


                                    <p class="h5">Targeted Supplementation:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Curcumin latte 1 sachet per day Omega-3 (triglyceride risk), Vitamin D3, Super Magnesium, Super Zinc, Methylated B-complex</li>
                                    </ul>

                                    <p class="  h5">Exercise:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Brisk walk 30 min/day, strength training 2x/week (aligned with endurance/power gene insights)</li>
                                    </ul>

                                    <p class="  h5">Lifestyle:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Stress management (guided by resilience-to-stress gene), sleep window fixed, alcohol restricted</li>
                                    </ul>

                                    <p class="mb-1 h5">Monitoring:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>90-day guided sessions with EPLIMO coach</li>
                                    </ul>

                                    <h4 class="problem_item mb-4">3.	Outcome</h4>
                                    <p class="mb-4 h5">Outcome (After 6 Months):</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Liver function: ALT/AST/GGT normalized </li>
                                        <li> Metabolic health: HbA1c down to 5.5, FBS 94 mg/dL</li>
                                        <li>Lipid profile: LDL 120, Triglycerides 135, HDL 42 </li>
                                        <li>Inflammation: hs-CRP dropped from 4.8 → 1.6 </li>
                                        <li>Vitamins: Vitamin D and B12 optimized </li>

                                    </ul>

                                    <h4 class="problem_item mb-4">4. Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">Visible changes: 8 kg weight loss, reduced belly fat, improved energy, clear sleep, no post-meal heaviness
                                        <br />
                                        <br />
                                        Imaging: Fatty liver reversed (Grade 1-0)

                                    </p>
                                </div>
                            </div>
                            <div id="case9" ref={caseRefs.case9}>
                                <div class="d-flex gap-4 mb-5 align-items-center" >
                                    <img src="assets/img/case9.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Cardiac Health & Wellness</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4 h5">Key Concerns:</p>
                                    <p>Age: 46 yrs.<br />
                                        Height: 5’2”<br />
                                        Weight: 80 kg</p>
                                    <p>Thyroid dysfunction for 10+ years, constant travel, erratic food habits, no exercise, peri-menopausal symptoms, running a business (high stress).</p>


                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li>↑ TSH (thyroid dysfunction) </li>
                                        <li>↑ Risk: Vitamin D, Magnesium, Zinc deficiency</li>
                                        <li>Graves’ disease (autoimmune trigger) </li>
                                        <li> Emotional eating + low stress resilience</li>
                                        <li> Iron & B6 metabolism challenges  </li>
                                    </ul>

                                    <h5 class="mb-4">DNA Findings</h5>
                                    <ul class="mb-4 dot_list">
                                        <li>Thyroid: Intermediate risk → elevated TSH tendency </li>
                                        <li>Nutrients: Vitamin D, Magnesium, Zinc, B6, Iron at high risk of deficiency </li>
                                        <li>Autoimmunity: High risk for Graves’ disease </li>
                                        <li> Metabolism: High-carb diet predisposes to weight gain</li>
                                        <li>Gut: Lactose intolerance → inflammation risk </li>
                                        <li>Stress: Low resilience → adrenal-thyroid imbalance </li>

                                    </ul>

                                    <h4 class="problem_item mb-4">2. Intervention   <small className='h5'>(Functional Medicine)</small> </h4>
                                    <p class="  h5 mb-3">Precision, Gene-Led Program:</p>
                                    <p class=" h5">Nutrition & Lifestyle:</p>

                                    <ul class=" dot_list">
                                        <li> Gluten-free, dairy-light, anti-inflammatory diet  </li>
                                        <li>  Regular meal timing (reduce cortisol spikes) </li>
                                        <li>  High-protein, low-carb diet (genetically favourable) </li>
                                        <li>  Yoga, breathwork, and structured sleep hygiene </li>
                                        <li>  Strength + walking (3×/week) </li>
                                    </ul>


                                    <p class="  h5">Targeted Supplementation:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Vitamin D3 + K2 (2000–5000 IU/day) </li>
                                        <li>Super Magnesium 2 per day </li>
                                        <li> Super Zinc- 2 times twice per day</li>
                                        <li>Selenium (100–200 mcg/day) </li>
                                        <li>Vitamin B6 (P5P 25–50 mg/day)</li>
                                        <li>Iron </li>
                                        <li> Omega-3 (1000 mg/day) </li>
                                        <li>Intuit + (L-glutamine, collagen)</li>
                                    </ul>



                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <ul class="mb-4 dot_list">
                                        <li>Improved thyroid function (TSH balance, T4→T3 conversion) Weight reduction (8–10 kg) </li>
                                        <li>Better energy, mood & focus (stress resilience improved) Peri-menopausal symptoms reduced </li>
                                        <li>Stronger bones (better Vitamin D, Magnesium, exercise) Lower autoimmune progression risk (Graves’/Hashimoto’s)  </li>
                                    </ul>

                                    <h4 class="problem_item mb-4">4.	Key Takeaway</h4>
                                    <p class="mb-4 pb-md-5">Sustainable lifestyle reset for long-term health</p>
                                </div>
                            </div>
                            <div id="case10" ref={caseRefs.case10}>

                                <div class="d-flex gap-4 mb-5 align-items-center">
                                    <img src="assets/img/case10.jpg" alt="research" class="case_h_img br20" />
                                    <h3 class="mb-0 fw600">Weight Loss</h3>
                                </div>

                                <div class="color_light">
                                    <h4 class="problem_item mb-4">1. Problem</h4>
                                    <p class="mb-4  ">Key Concerns:</p>
                                    <p>Gender: Female<br />
                                        Age: 52<br />
                                        Weight: Reduced from 75 kg to 66 kg in 47 days
                                    </p>
                                    <p>For years, the client had struggled with stubborn weight gain. Despite several diet and exercise attempts, results never lasted. She often felt:</p>


                                    <ul class="mb-4 dot_list">
                                        <li> Frustrated: Tried multiple programs but saw little change. </li>
                                        <li> Low on motivation: Found it hard to stay consistent with workouts. </li>
                                        <li> Fatigued: Energy crashes made daily life difficult. </li>
                                        <li> Self-conscious: Comments from others affected her confidence. </li>

                                    </ul>

                                    <h5 class="mb-4">EPLIMO - Underlying Genetic Risks Identified:</h5>
                                    <ul class="mb-4 dot_list">
                                        <li> High BMI Risk: Genetic predisposition to higher weight and difficulty maintaining it. </li>
                                        <li> Carb Sensitivity – Intermediate Risk: More likely to gain fat on high-carb diets. </li>
                                        <li> Insulin Sensitivity – Intermediate Risk: Elevated insulin response promotes fat storage. </li>
                                        <li> Magnesium & Zinc Deficiency – High Risk: Slows metabolism and energy production. </li>
                                        <li> Low Exercise Motivation: Genetic variant reduces drive for physical activity. </li>
                                        <li> Weak Ligament Strength & Higher Muscle Soreness: Slower recovery, higher injury risk.</li>
                                        <li> Positive Response to High-Protein Diet: Performs best on a high-protein, low-carb plan. </li>
                                        <li> Low Risk of Weight Regain: Easier long-term maintenance once weight is lost. </li>


                                    </ul>
                                    <p>Conventional programs failed because they ignored her unique genetic and metabolic profile.</p>

                                    <h4 class="problem_item mb-4">2. Intervention    <small className='h5'>(Functional Medicine) </small> </h4>
                                    <p class="mb-4  h5">Precision, Gene-Led Program:</p>
                                    <p class=" h5">Nutrition (Gene-Matched):</p>

                                    <ul class=" dot_list">
                                        <li> High-protein, low-carb plan to accelerate fat loss.</li>
                                        <li> Fiber-rich meals for gut health and satiety.</li>
                                        <li> Magnesium & zinc supplementation to correct deficiencies and boost energy.</li>
                                        <li> Optimized meal timing to stabilize blood sugar and enhance fat-burning.</li>
                                    </ul>


                                    <p class="  h5">Lifestyle & Exercise Plan:</p>
                                    <ul class="mb-4 dot_list">
                                        <li>Low-impact, progressive workouts minimize injury risk. </li>
                                        <li>Gradual inclusion of walking and strength training. </li>
                                        <li> Weekly coaching sessions to strengthen consistency and motivation.</li>

                                    </ul>
                                    <p class="  h5">Behavioral Focus:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Practical methods to control cravings and emotional eating.</li>
                                        <li> Focus shift from “eating less” to “eating right.”</li>
                                    </ul>


                                    <h4 class="problem_item mb-4">3. Outcome</h4>
                                    <p class="  h5">Outcome (After 47 Days):</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Weight Loss: 9 kg reduction (75 → 66 kg) without crash dieting. </li>
                                        <li> Body Composition: Noticeable inch loss around the waist and hips.  </li>
                                        <li> Energy: Sustained vitality with no midday slumps. </li>
                                        <li>Confidence: Renewed self-image and willingness to socialize.   </li>
                                        <li>  Lifestyle: Regular exercise became part of her routine. </li>
                                        <li> Metabolism: Improved flexibility, fewer cravings, better satiety.  </li>

                                    </ul>

                                    <p class="  h5">Outcome:</p>
                                    <ul class="mb-4 dot_list">
                                        <li> Her low genetic risk for weight regain ensures these results are sustainable. </li>

                                    </ul>


                                    <h4 class="problem_item mb-4">4.	Key Takeaway</h4>
                                    <p class="mb-4  "> When weight-loss plans are personalized through genetics, effort turns into empowerment.<br />
                                        By aligning nutrition, lifestyle, and mindset with her genetic blueprint, this client achieved a transformation that enhanced energy, confidence, and overall quality of life, proving that sustainable change starts with self-understanding.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>


            <Faq />



            <section className="you_ready_sec  position-relative  overflow-hidden">
                <img src="/assets/img/plan/you-ready-bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/plan/you-ready-bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check.  It’s a blueprint for living stronger, longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div>
                    </div>
                </div>
                 <FormModal show={show} setShow={setShow} />
            </section>

            <Footer /> </section>
        </>
    );
}

export default Casestudy;
